'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal() {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    _createClass(Modal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                title = _props.title,
                message = _props.message,
                option = _props.option,
                close = _props.close,
                image = _props.image;

            var len = option.length;
            var classNames = len === 2 ? 'layer-btn-item left-right' : 'layer-btn-item top-bottom';
            var onlyTitle = title && !message;
            return _react2.default.createElement(
                'div',
                { className: 'layer-window' },
                image && _react2.default.createElement('img', { className: 'layer-img', src: image }),
                _react2.default.createElement(
                    'div',
                    { className: 'layer-wrap' },
                    _react2.default.createElement(
                        'article',
                        { className: onlyTitle ? "layer-onlytitle" : "" },
                        title && _react2.default.createElement(
                            'div',
                            { className: 'layer-window-head' },
                            title
                        ),
                        message && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: message } })
                    ),
                    len > 0 && _react2.default.createElement(
                        'div',
                        { className: 'layer-window-foot' },
                        option.map(function (item, i) {
                            return _react2.default.createElement(
                                'div',
                                { key: i, className: i == 0 && len > 1 ? classNames + ' left' : classNames, onClick: function onClick() {
                                        item.fn && item.fn();
                                        close(_this2.props.id);
                                    } },
                                item.text
                            );
                        })
                    ),
                    _react2.default.createElement('a', { onClick: function onClick() {
                            close(_this2.props.id);
                        }, href: 'javascript:;', className: 'layer-close', title: '\u5173\u95ED' })
                )
            );
        }
    }]);

    return Modal;
}(_react.Component);

exports.default = Modal;


Modal.propTypes = {
    id: _propTypes2.default.string,
    title: _propTypes2.default.string,
    message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    option: _propTypes2.default.array
};

Modal.defaultProps = {
    option: []
};
module.exports = exports['default'];